<template>
	<payHeader :bgStatus="bgStatus"></payHeader>
	<div class="register-main">
		<div class="section">
			<div class="title">注册<p class="btn">注册已有蓝队云账号，<router-link to="/login">立即登录&nbsp;&gt;</router-link></p></div>
			<el-form :rules="rules" ref="ruleFormRef" :model="groupForm" status-icon inline-message>
				<el-form-item class="mobile" prop="mobile">
					<span class="label">手机号</span>
					<el-input v-model="groupForm.mobile" @blur="checkChange('mobile')" placeholder="常用的手机号码，用于接收通知信息" autocomplete="off" />
				</el-form-item>
				<el-form-item class="name" prop="user_name">
					<span class="label">用户名</span>
					<el-input v-model="groupForm.user_name" @blur="checkChange('username')" placeholder="6-14位字符" autocomplete="off" />
					<el-tooltip effect="dark" content="6-14位字符，英文字母、数字的任意组合">
						<el-icon style="margin-left: 5px;"><Warning color="#ff6600" /></el-icon>
					</el-tooltip>
				</el-form-item>
				<el-form-item class="pwd" prop="password">
					<span class="label">密码</span>
					<el-input v-model="groupForm.password" @blur="checkChange('password')" type="password" show-password autocomplete="off" />
					<span class="level">
						<el-text type="warning" v-if="level == '中'">{{level}}</el-text>
						<el-text type="success" v-if="level == '强'">{{level}}</el-text>
						<el-text type="danger" v-if="level == '弱'">{{level}}</el-text>
					</span>
					<el-tooltip effect="dark" content="密码长度8~16字符,包含大写字母、小写字母、数字及特殊符号中至少三项">
						<el-icon style="margin-left: 5px;"><Warning color="#ff6600" /></el-icon>
					</el-tooltip>
				</el-form-item>
				<el-form-item class="pwd" prop="password_confirm">
					<span class="label">确认密码</span>
					<el-input v-model="groupForm.password_confirm" type="password" placeholder="请再次输入确认密码" show-password autocomplete="off" />
				</el-form-item>
				<el-form-item class="code" prop="sms_code">
					<span class="label">验证码</span>
					<el-input v-model="groupForm.sms_code" autocomplete="off" />
					<el-button type="primary" :disabled="codeSend" @click="codeChange">{{codeSendText}}</el-button>
				</el-form-item>
				<div class="agree">
					<el-checkbox v-model="agreementChecked" label="我已阅读并同意" size="large" />
					<span class="tip"><a :href="domain+'/agreement/register.html'" target="_blank">《蓝队云服务协议》</a><a :href="domain+'/agreement/statement.html'" target="_blank">《法律声明及隐私权政策》</a></span>
				</div>
				<el-form-item>
					<el-button type="primary" class="submit" :disabled="!agreementChecked" @click="submitForm(ruleFormRef)">注册</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
	<el-dialog align-center :close-on-click-modal="false" v-model="captchaVisible" title="请输入图片中的验证码" width="280">
		<el-image :src="captchaImg" @click="captchaReload" fit="contain" alt="验证码" title="点击刷新" style="margin-bottom: 10px;cursor: pointer;" />
	    <el-form class="captcha-form">
	      <el-form-item label="验证码">
	        <el-input v-model="captchaAnswer" autocomplete="off" />
	      </el-form-item>
	    </el-form>
	    <template #footer>
	      <div class="dialog-footer">
	        <el-button type="primary" @click="sendCodeClick">发送验证码</el-button>
	      </div>
	    </template>
	</el-dialog>
	<payFooter></payFooter>
</template>

<script setup>
	import { ref,reactive,inject,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import { useStore } from 'vuex';
	import { ElMessage,ElMessageBox,ElNotification } from 'element-plus';
	import { registerCheck,captchaFetch,registerSendCode,register } from '@/api/home';
	import { Warning } from '@element-plus/icons-vue';
	import { payHeader,payFooter } from 'landui-ui';
	
	const store = useStore();
	const router = useRouter();
	const domain = inject('domain');
	const bgStatus = ref(true);
	const level = ref('');
	const agreementChecked = ref(false);
	const codeSendText = ref('短信验证码');
	const codeSend = ref(false);
	const codeType = ref('sms');
	const codeTime = ref(60);
	const captchaVisible = ref(false);
	const captchaAnswer = ref('');
	const captchaImg = ref('');
	const captchaId = ref('');
	const ruleFormRef = ref(null);
	const groupForm = ref({user_name:'',password:'',password_confirm:'',mobile:''});
	const passValidate = (rule, value, callback) => {
		var count = 0;
		if(/\d/.test(value)) count++
		if(/[a-z]/.test(value)) count++
		if(/[A-Z]/.test(value)) count++
		if(/[_。%#@]/.test(value)) count++
		if(count < 3) {
			callback(new Error('密码必须包含大写字母、小写字母、数字及特殊符号中至少三项'))
		} else {
			callback()
		}
	};
	const passValidate2 = (rule, value, callback) => {
		if (value === '') {
			callback(new Error('请再次填写新密码'))
		} else if(value !== groupForm.value.password){
			callback(new Error('两次填写的密码不一致'))
		} else {
			callback()
		}
	};
	const rules = reactive({
		user_name: [
			{ required: true, message: '6-14位字符，英文字母、数字的任意组合', trigger: 'blur' },
			{ min: 6,max:14, message: '6-14位字符，英文字母、数字的任意组合', trigger: 'blur' },
		],
		password: [
			{ required: true, message: '密码长度8~16字符,包含大写字母、小写字母、数字及特殊符号中至少三项', trigger: 'blur' },
			{ min: 8,max:16, message: '密码长度8~16字符,包含大写字母、小写字母、数字及特殊符号中至少三项', trigger: 'blur' },
			{ validator: passValidate, trigger: 'blur' }
		],
		password_confirm: [
			{ required: true, message: '请再次填写密码', trigger: 'blur' },
			{ validator: passValidate2, trigger: 'blur' }
		],
		mobile: [
			{ required: true, message: '请填写手机号码', trigger: 'blur' },
			{ min: 11,message: '请填写正确手机号码格式', trigger: 'blur' }
		],
		sms_code: [
			{ required: true, message: '请填写验证码', trigger: 'blur' }
		]
	});
	
	
	const checkChange = (val) => {
		switch(val)
		{
			case 'mobile':
				checkF(val,groupForm.value.mobile)
			break;
			case 'username':
				checkF(val,groupForm.value.user_name)
			break;
			case 'password':
				checkF(val,groupForm.value.password)
			break;
		}
	}
	const checkF = (type,value) => {
		const param = {'type':type,'field_value':value}
		if (value != '') {
			registerCheck(param).then((res) => {
				if (res.code == 200) {
					if (!res.data.is_valid) {
						ElNotification({
						    title: '提示',
						    message: res.msg,
						    type: 'error',
						})
					}
					if (type == 'mobile') {
						if (res.data.mobile_register_num > 0 && res.data.mobile_register_num < 3) {
							ElMessageBox.confirm(
							    '您的手机号已有绑定账户，您可立即登录或继续注册！',
							    '温馨提示',
							    {
							      confirmButtonText: '立即登录',
							      cancelButtonText: '继续注册',
								  closeOnClickModal: false,
								  showClose:false,
								  autofocus: false,
							      type: 'warning',
							    }
							)
							.then(() => {
								router.push({ path: '/login' })
							})
							.catch(() => {
								
							})
						}
						if (res.data.mobile_register_num == 3) {
							ElMessageBox.confirm(
							    '您的手机号已绑定3个账户，无法注册新账户，请登录！',
							    '温馨提示',
							    {
							      confirmButtonText: '登录',
							      cancelButtonText: '取消',
								  closeOnClickModal: false,
								  showClose:false,
								  autofocus: false,
							      type: 'warning',
							    }
							)
							.then(() => {
								router.push({ path: '/login' })
							})
							.catch(() => {
								
							})
						}
						if (res.data.mobile_register_num > 3) {
							ElMessageBox.confirm(
							    `您的手机号已注册${res.data.mobile_register_num}个账号，手机号不能绑定超过3个账号，不符合新规，如果忘记账号密码，请联系客服处理！`,
							    '温馨提示',
							    {
								  confirmButtonText: '确定',
								  showCancelButton: false,
								  closeOnClickModal: false,
								  showClose:false,
								  autofocus: false,
								  type: 'warning',
							    }
							)
							.then(() => {
								
							})
							.catch(() => {
								
							})
						}
					}
					if (type == 'password') {
						level.value = res.data.password_strong_level !== '' ? res.data.password_strong_level:'';
					}
				}
			})
		}
	}
	const captchaChange = () => {
		captchaFetch().then((res) => {
			if (res.code == 200) {
				captchaImg.value = res.data.captcha_data;
				captchaId.value = res.data.captcha_id;
			}
		})
	}
	const captchaReload = () => {
		captchaChange()
	}
	const codeChange = () => {
		if (groupForm.value.mobile == '') {
			ElMessage({
				offset: 110,
				message: '请填写手机号码',
				type: 'error'
			})
		} else{
			captchaChange()
			captchaVisible.value = !captchaVisible.value;
		}
	}
	const sendCodeClick = () => {
		const param = {
			'captcha_answer':captchaAnswer.value,
			'captcha_id':captchaId.value,
			'mobile':groupForm.value.mobile,
			'type':codeType.value
		}
		registerSendCode(param).then((res) => {
			if (res.code == 200) {
				codeSend.value = true;
				codeSendText.value = codeTime.value+'s后重新发送';
				let timer = setInterval(() => {
				   codeTime.value--;
				   codeSendText.value = codeTime.value + 's后重新发送';
				   if (codeTime.value < 0) {
					   clearInterval(timer);
					   codeSendText.value = '语音验证码';
					   if(codeType.value == 'sms'){
							codeType.value = 'vms'
					   }
					   codeTime.value = 60;
					   codeSend.value = false
				   }
				}, 1000)
				captchaVisible.value = !captchaVisible.value;
			}else{
				captchaChange()
				captchaAnswer.value = ''
			}
		})
	}
	const submitForm = () => {
		if (!ruleFormRef.value) return;
		ruleFormRef.value.validate((valid) => {
			if (valid) {
				groupForm.value.agreement_checked = agreementChecked.value;
				const param = groupForm.value;
				register(param).then((res) => {
					if(res.code === 200){
						ElMessageBox.confirm(
						    '恭喜您已注册成为蓝队云会员！',
						    '温馨提示',
						    {
						      confirmButtonText: '确定',
						      showCancelButton: false,
						      closeOnClickModal: false,
						      showClose:false,
						      type: 'success',
						    }
						)
						.then(() => {
							router.push({ path: '/registerWx' })
							// window.location.href = domain.value+"/index/user/registerWx";
						})
						.catch(() => {
							
						})
					}
				})
			} else {
			  return false;
			}
		});
	};

	
</script>

<style lang="scss">
	.captcha-form{
		.el-form-item{
			.el-form-item__label{height: 40px; line-height: 40px;}
			.el-input{
				height: 40px;
				--el-input-height:40px;
			}
		}
	}
	.register-main{
		background: #f5f8fa;
		padding: 135px 0 40px;
		min-width: 1280px;
		overflow: hidden;
		.section{
			width: 1000px;margin: 0 auto;padding: 25px 0 65px;background: #fff;
			.title{
				text-align: center; 
				font-size: 20px; 
				margin-bottom: 20px;
				line-height: 28px;
				position: relative;
				overflow: hidden;
				.btn{ position: absolute; right: 35px;top: 0;color: #888888; font-size: 14px;}
			}
			.el-form{
				margin-left: 320px;
				.el-form-item{
					position: relative;
					.el-input{
						width: 360px !important;
						height: 45px;
						--el-input-height:45px;
					}
					.el-input__suffix{margin-right: 5px;}
					.el-input__wrapper{padding: 1px}
					.el-input__inner{padding-left: 95px;}
					.label{
						width: 80px;
						padding-left: 12px;
						color: #999999;
						border-right: 1px solid #ddd;
						height: 43px;
						line-height: 43px;
						position: absolute;
						left: 0;
						top: 1px;
						z-index: 1;
					}
					.level{position: absolute;left: 300px; color: red;}
				}
				.code{
					overflow: visible;
					.el-button{position: absolute;left: 244px;top: 7px;width: 110px; text-align: center;}
				}
				.other{
					text-align: right;
					margin-bottom: 16px;
					overflow: hidden;
					span{cursor: pointer;color: #015bfe;}
				}
				.agree{
					margin: -8px 0 25px 0;
					overflow: hidden;
					.tip{display: inline-block;vertical-align: middle;margin-top: -7px;}
				}
				.submit{
					width: 360px;
					height: 48px;
					line-height: 48px;
					font-size: 18px;
				}
			}
		}
	}
</style>